import React, { useMemo, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from 'components/Types/GeneralTypes';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import AnularSVG from "assets/icons/Permisos/anularXazul.svg"
import InterrupcionSVG from "assets/icons/Permisos/PerdidaEMBARAZO.svg"

export default function TableNotificacionEmbarazo({ dataFilas, onClickVerDocumento, onClickAnular }) {


    const filas = useMemo(
        () => [...dataFilas], [dataFilas]
    )

    function GenerarCellAcciones(data) {
        const fechaActual = new Date();
        const fechaCertificado = new Date(data.notificacion.fechacertificado);
        const fechaEstimadaParto = new Date(data.notificacion.fechaestimadaparto);
        const iconoDescargarEvidencia = (
            <i
                data-toggle="tooltip" data-placement="top" title="Descargar Evidencia"
                onClick={() => onClickVerDocumento(data.notificacion.refarchivo)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Descargar Evidencia"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Descargar Evidencia"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        
        const iconoAnularSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Interrupción de Embarazo"
                onClick={() => onClickAnular(data.notificacion)}
            >
                <img
                    src={InterrupcionSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Interrupción de Embarazo"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Interrupción de Embarazo"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const contentAccion = (
            <React.Fragment>
                {iconoDescargarEvidencia}
                {fechaActual >= fechaCertificado && fechaActual <= fechaEstimadaParto && data.notificacion.fechainterrupcion === null && iconoAnularSolicitud}

            </React.Fragment>
        )
        return contentAccion
    }

    const columnas: any = React.useMemo(
        () => [
            {
                Header: 'Fecha Certificado',
                accessor: 'fechacertificado',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Semanas',
                accessor: 'semanascertificado',

            },
            {
                Header: 'Fecha Estimada de Parto',
                accessor: 'fechaestimadaparto',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

            },
            {
                Header: 'Fecha Interrupción',
                accessor: 'fechainterrupcion',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

            },
            {
                Header: "Acciones",
                accessor: (row) => ({
                    notificacion: row,
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            }

            ,
        ], [dataFilas]
    )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
        {
            HeaderName: "Estado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Acciones',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Semanas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Certificado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Registro",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Estimada de Parto",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Interrupción",
            StyleHeader: {
                textAlign: "center"
            }
        }
    ]

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;





    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>



        </React.Fragment>
    )
}